<template>
  <div class="models">
    <div class="header">
        <h2>Models</h2>
    </div>

    <div class="next">
        <button class="empty" @click="logout">Logout</button>
        <div class="right">
            <div class="credits" v-if="credits !== '-'">
                <img src="/static/emerald.png" alt="" height="20">
                <span>{{ credits }}</span>
            </div>
            <button @click="$router.push('/models/create/models_type')">New AI Model</button>
        </div>
    </div>

    <div class="options" v-if="loading">
        <loader></loader>
    </div>
    <div class="options" v-else>

        <div class="rows" v-if="loading">
            <div class="row loading">
                <span>Loading AI Models...</span>
            </div>
        </div>

        <div class="rows" v-else-if="models.length === 0">
            <div class="row">
                <span>You have not created any AI models yet.</span>
                <button @click="$router.push('/models/create/models_type')">Create a new AI model</button>
            </div>
        </div>

        <div class="rows">
            <div class="row action" v-for="model in models" :key="model.id" @click="$router.push('/models/' + model.id)">
                <div class="start">
                    <span class="name">{{ model.name }} ({{ model.analyzer_type.toUpperCase() }})</span>
                </div>
                <div class="end">
                    <span>{{ new Date(model.created_at).toLocaleDateString('nl-NL') }}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import config from '../config';
import Loader from './Loader.vue';

import { getCredits } from '../api';

export default {
    name: 'Models',
    components: {
        Loader
    },
    data () {
        return {
            models: [],
            loading: false,
            credits: '-',
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('token');
            this.$router.push('/login');
        },
        getCredits() {
            getCredits()
                .then(credits => {
                    this.credits = credits;
                })
                .catch(error => {
                    this.credits = '-'
                    if (error.message === '403') {
                        this.$router.push('/login');
                    }
                    else
                        this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: 'Could not load credits.', duration: 3000 });
                });
        },
        getModels() {
            this.loading = true;
            const token = localStorage.getItem('token');

            fetch(config.api + '/models', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(data => {
                this.models = data;
            })
            .catch(error => {
                if (error.message === '403') {
                    this.$router.push('/login');
                }
                else
                    this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: 'Could not load models.', duration: 3000 });
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.getModels();
        this.getCredits();
    }
}
</script>

<style scoped>

.rows {
    width: 900px;
}

.row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    padding: 10px 20px;
    margin: 10px 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    transition: 200ms;
    color: rgb(122, 122, 122);
    user-select: none;
    font-size: 14px;
}

.action {
    cursor: pointer;
}

.action:hover {
    background-color: rgb(240, 240, 240);
    transition: 200ms;
    cursor: pointer;
}

.action:active {
    background-color: rgb(230, 230, 230);
    transition: 200ms;
    box-shadow: none;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    animation: loading 2s linear infinite;
}

@keyframes loading {
    0% {
        background-color: rgb(240, 240, 240);
    }
    50% {
        background-color: rgb(216, 216, 216);
    }
    100% {
        background-color: rgb(240, 240, 240);
    }

}

.right {
    display: flex;
    align-items: center;
}

.credits {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 20px;
    color: rgb(142, 142, 142);
    user-select: none;
}

</style>


// WEBPACK FOOTER //
// src/components/Models.vue